export default __webpack_public_path__ + "static/media/suggestreport.5a6751dc.svg";